module.exports = __webpack_public_path__ + "static/media/VM_logo.2a5156cb.svg";